import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import LinkWrapper from "../linkWrapper/LinkWrapper";

const readDismissed = (key) => {
    try {
        return sessionStorage.getItem(key) === "1";
    } catch (e) {
        return false;
    }
};

// Dismissible promo message above the header. The dismissal lives in sessionStorage, so it
// holds for the visit and comes back with the next one. When the text is wider than the bar
// (small screens) it scrolls as a ticker instead of being cut off.
const PromoBar = ({ text, link, storageKey }) => {
    const [dismissed, setDismissed] = useState(() => readDismissed(storageKey));
    const [ticker, setTicker] = useState(false);
    const trackRef = useRef(null);
    const textRef = useRef(null);

    useEffect(() => {
        const check = () => {
            if (trackRef.current && textRef.current) setTicker(textRef.current.scrollWidth > trackRef.current.clientWidth + 1);
        };
        check();
        window.addEventListener("resize", check);
        return () => window.removeEventListener("resize", check);
    }, [text, dismissed]);

    if (dismissed) return null;

    const dismiss = () => {
        setDismissed(true);
        try {
            sessionStorage.setItem(storageKey, "1");
        } catch (e) {
            // storage blocked: the bar simply reappears on the next load
        }
    };

    return (
        <div className="shop-header__promo" role="region" aria-label="Promotion">
            <div className="container shop-header__promo-inner">
                <div ref={trackRef} className="shop-header__promo-track">
                    <LinkWrapper linkNode={link || {}} renderChildren linkClass="shop-header__promo-link">
                        <span ref={textRef} className={`shop-header__promo-text ${ticker ? "shop-header__promo-text--ticker" : ""}`}>
                            {text}
                        </span>
                    </LinkWrapper>
                </div>
                <button type="button" className="shop-header__promo-close" onClick={dismiss} aria-label="Dismiss promotion">
                    <i className="pe-7s-close" />
                </button>
            </div>
        </div>
    );
};

PromoBar.propTypes = {
    link: PropTypes.object,
    storageKey: PropTypes.string,
    text: PropTypes.string,
};

export default PromoBar;